import React, { forwardRef } from 'react';

import { openRealignModalAction } from 'components/RealignModal/redux/actions';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { VerticallyAlignedFlexContainer } from 'styles/common';
import { checkUserIsIndividualContributor } from 'utils/helpers/rolesAccess';

import { RealignSvgIcon } from 'constants/icons';
import theme from 'constants/theme';

import { Typography13, Typography14 } from 'uiToolkit/Typography';

import { RestrictedAccessContainerWithTooltip } from '../DetailSection/GoalDetailSection';
import { HeaderText } from '../Goals/GoalHelperComponents';
import ObjectivesAndKRs from './ObjectivesAndKRs';

const AlignmentSection = ({
  reason = '',
  disabled = false,
  goalDetails = {},
  updateGoal = () => {},
  showHeader = true,
  isAlignmentAtParentLevel = false,
  setTimeboundDetails = () => {},
}) => {
  const dispatch = useDispatch();

  const selectedObjective = goalDetails?.subObjective;

  if (isAlignmentAtParentLevel) {
    return <Typography14 customColor={theme.palette.text.primary}>At parent level</Typography14>;
  }

  const onClickHandler = () => {
    dispatch(
      openRealignModalAction({
        objectiveId: selectedObjective?.objectiveId,
        realignId: selectedObjective?.objectiveTimeBoundId,
        // objectiveName: selectedObjective?.displayName,
        selectedTimeBoundPeriod: selectedObjective?.timeBoundDetails,
        selectedObjective: {
          timeBoundDetails: selectedObjective?.timeBoundDetails,
          objectiveId: selectedObjective?.objectiveId,
        },
        onSelect: (tag) => {
          // console.log({ tag });
          // updateGoal({ ...goalDetails, subObjective: tag });
          updateGoal({
            ...goalDetails,
            parentTaskId: tag.postCardId,
            subObjective: {
              ...tag,
              objectiveType: 'GOAL',
            },
          });
        },
        krName: goalDetails?.text,
        krId: goalDetails?.id,
      })
    );
  };

  const isUserIndividualContributor = checkUserIsIndividualContributor();
  return (
    <RestrictedAccessContainerWithTooltip reason={reason} disabled={disabled}>
      {showHeader && (
        <VerticallyAlignedFlexContainer>
          <HeaderText topGutter={1} weight={600}>
            Alignment
          </HeaderText>
          {/* <GoalObjectiveField taskDetails={goalDetails} updateTask={updateGoal} isRealign>
              <RealignSvgIcon
                containerSize="fixed24px"
                circular
                size="fixed14px"
                color="primary"
                style={{ border: `1px solid ${theme.palette.icons.blue}`, marginRight: '0.5rem' }}
              />

              <HeaderText color="primary">Realign</HeaderText>
            </GoalObjectiveField> */}

          <VerticallyAlignedFlexContainer onClick={onClickHandler} style={{ marginLeft: 'auto', cursor: 'pointer' }}>
            <RealignSvgIcon
              containerSize="fixed24px"
              circular
              size="fixed14px"
              color="primary"
              style={{ border: `1px solid ${theme.palette.icons.blue}`, marginRight: '0.5rem' }}
            />

            <Typography13 weight={400} color="primary">
              Realign
            </Typography13>
          </VerticallyAlignedFlexContainer>
        </VerticallyAlignedFlexContainer>
      )}

      <ObjectivesAndKRs goalDetails={goalDetails} />
    </RestrictedAccessContainerWithTooltip>
  );
};

export const RefableAlignmentSection = forwardRef((props, ref) => (
  <div ref={ref}>
    <AlignmentSection {...props} />
  </div>
));

const ObjectivesContainer = styled.div`
  width: 100%;
  border-radius: 4px;
  border: 1px solid ${(props) => props.theme.palette.divider};
`;

export default AlignmentSection;
